/**
 * Entry point: imports CSS, initializes the app.
 */

import "./style.css";
import { initApp } from "./ui/app";

initApp();
